import { serviceRequest } from 'utils/http';
import { ReferralService, SponsorPatientIDDto } from 'common/api';

export function updateReferralSponsorPatientIdAPI(
  sponsorPatientIDDto: SponsorPatientIDDto
) {
  return serviceRequest(() =>
    ReferralService.referralControllerAddSponsorPatientId(sponsorPatientIDDto)
  );
}
